<template>
    <div v-show="value">
        <div>
            <div class="meterWrap"><b-progress :value="passwordStrength.score + 1" max="5"
                    :class="meterClasses" :variant="meterVariant"></b-progress>
            </div>
            {{meterText}}
        </div>
        <div>{{$t('timeToCrack',
            { time: passwordStrength.crack_times_display.online_no_throttling_10_per_second })}}</div>
        <div v-if="warning" class="warning">{{warning}}</div>
        <div v-if="extraError" class="warning">{{extraError}}</div>
        <b-card v-if="suggestions.length > 0" text-variant="info">
            <div v-for="(s, ind) in suggestions" :key="ind" class="suggestions">{{s}}</div>
        </b-card>

    </div>
</template>

<script>
import zxcvbn from 'zxcvbn';

export default {
  name: 'passwordStrengthIndicator',
  props: {
    value: String,
    minLength: Number,
    extraError: String
  },
  computed: {
    passwordStrength() {
      const strength = zxcvbn(this.value,
        [ this.$store.state.username, ...this.$store.state.settings.passwordwords ]);
      this.$emit('score', strength);
      return strength;
    },
    warning() {
      if (this.value.length < this.minLength) {
        return this.$t('tooShort', { minLength: this.minLength });
      }
      return this.passwordStrength.feedback.warning;
    },
    suggestions() {
      return this.passwordStrength.feedback.suggestions;
    },
    meterClasses() {
      return { meter: true, [`meter-${this.passwordStrength.score}`]: true };
    },
    meterVariant() {
      return ['danger', 'danger', 'warning', 'info', 'success'][this.passwordStrength.score];
    },
    meterText() {
      return this.$t(`meter_${this.passwordStrength.score}`);
    }
  }
};
</script>

<style scoped lang="scss">
    @import '../assets/bootstrap-style.scss';

    .warning {
        color: $danger
    }
    .meterWrap {
        display: inline-block;
        .meter {
            width: 200px;
        }
    }

</style>
